/* eslint-disable */
import { useFormState } from "react-final-form";
import { Field } from "react-final-form";
import { CURRENCY_SYMBOLS } from "./constant";

export default function FinalTotalForm({from}) {
  const { values } = useFormState();
  const required = (value) => (value ? undefined : "Required");
  const COMPANY = window.COMPANY;
  function calculateTotals(products) {
    let totalAmount = 0;
    let totalDiscount = 0;

    products.forEach((item) => {
      const rate = Number(item.rate) || 0;
      const quantity = Number(item.quantity) || 0;
      const discount = Number(item.discount) || 0;

      totalAmount += rate * quantity;
      totalDiscount += discount;
    });

    const amountAfterDiscount =
      totalAmount - (totalAmount * (Number(values?.discount_value) || 0)) / 100;

    return {
      totalAmount: Number(totalAmount.toFixed(2)),
      totalDiscount: Number(totalDiscount.toFixed(2)),
      finalAmount: Number((
      amountAfterDiscount +
      (amountAfterDiscount * (Number(values?.tax) || 0)) / 100
      ).toFixed(2)),
    };
  }

  const getImagePreview = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value; // URL from backend
    if (value instanceof File) return URL.createObjectURL(value); // File object
    return "";
  };

  const totals = calculateTotals(from == 'quote' ? values?.items || [] : values?.invoice_products || []);
console.log("totals", totals);
  return (
    <div className="col-xl-6 col-lg-12">
      <div className="form-group-bank">
        <div className="invoice-total-box">
          <div className="invoice-total-inner">
            <p>
              Amount{" "}
              <span>
                {CURRENCY_SYMBOLS[COMPANY.currency_type]} {totals?.totalAmount}
              </span>
            </p>
            <div
              style={{
                marginTop: "10px",
              }}
            >
              Discount{" "}
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <span>
                  <Field
                    name="discount_value"
                    component="input"
                    type="number"
                    className="form-control"
                    placeholder="Enter %"
                    style={{
                      display: "inline-block",
                      width: 200,
                      marginRight: "5px",
                    }}
                  />
                  %
                </span>
                <span>
                  {window.COMPANY.currency_symbol}
                  {(
                    (totals?.totalAmount *
                      (Number(values?.discount_value) || 0)) /
                    100
                  ).toFixed(2)}
                </span>
              </span>
            </div>
            <div
              style={{
                marginTop: "10px",
              }}
            >
              Total Tax{" "}
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <span>
                  <Field
                    name="tax"
                    component="input"
                    type="number"
                    className="form-control"
                    placeholder="Enter %"
                    style={{
                      display: "inline-block",
                      width: 200,
                      marginRight: "5px",
                    }}
                  />
                  %
                </span>
                <span>
                  {window.COMPANY.currency_symbol}
                  {(
                    ((totals?.totalAmount -
                      (totals?.totalAmount *
                        (Number(values?.discount_value) || 0)) /
                        100) *
                      (Number(values?.tax) || 0)) /
                    100
                  ).toFixed(2)}
                </span>
              </span>
            </div>
          </div>
          <div
            className="invoice-total-footer"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              marginTop: "26px",
            }}
          >
            <h4>Total Amount</h4>
            <h4>
              {window.COMPANY.currency_symbol}
              {totals?.finalAmount}
            </h4>
          </div>
        </div>
        <div className="input-block mb-3">
          <label>Signature Name</label>
          <Field
            name="signature_name"
            component="input"
            type="text"
            className="form-control"
            placeholder="Enter Signature Name"
          />
        </div>
        <div className="col-xl-12 col-lg-12 col-12">
          <div className="input-block mb-4">
            <label>Signature image</label>
            <div className="input-block service-upload logo-upload mb-0">
              <div
                container
                style={{
                  width: "100%",
                  marginTop: 10,
                }}
              >
                <span className="sites-logo">
                  {!values?.signature_image ? (
                    "No signature Present. Please add from settings"
                  ) : (
                    <img
                      src={getImagePreview(values?.signature_image)}
                      width={100}
                      height={100}
                      alt="upload"
                    />
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
